import Vue from 'vue';
import VueRouter from 'vue-router';
import hooks from './router.hooks';

import PageSearch from '@/views/PageSearch.vue';
import PageSearch2 from '@/views/PageSearch2.vue';
import PageSearchResults from '../views/PageSearchResults.vue';
import PageContent from '../views/PageContent.vue';
import PageLogin from '../views/PageLogin.vue';
import PageRW from '../views/PageRW.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    redirect: '/search2',
  },
  {
    path: '/search',
    name: 'search',
    component: PageSearch,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/search2',
    name: 'search2',
    component: PageSearch2,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/search/results',
    name: 'search-results',
    component: PageSearchResults,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/search2/results',
    name: 'search2-results',
    component: PageSearchResults,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/content/:id',
    name: 'content',
    component: PageContent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/login',
    name: 'login',
    component: PageLogin,
  },
  {
    path: '/post-booking',
    name: 'RW',
    component: PageRW,
    meta: {
      requiresAuth: true,
    },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(hooks);

export default router;
